import Tooltip from "@/src/components/Tooltip";
import TooltipButton from "@/src/components/Tooltip/components/TooltipButton";
import TooltipPanel from "@/src/components/Tooltip/components/TooltipPanel";
import { Body8 } from "@/src/components/typography/components/Body";
import { Label4 } from "@/src/components/typography/components/Label";
import { IconSize } from "nvs-design-system/dist/IconContainer";
import { InfoCircle } from "nvs-ds-icons";

const TooltipButtonPanel = ({
  label,
  tooltipCopy,
  className,
  buttonAriaLabel = `Get more information on ${label.toLowerCase()}`,
}: {
  label: string;
  tooltipCopy: string;
  className?: string;
  buttonAriaLabel?: string;
}) => {
  return (
    <Tooltip className={className}>
      <TooltipButton
        label={buttonAriaLabel}
        icon={<InfoCircle className="hover:fill-white hover:text-black" />}
        size={IconSize.sm}
      />
      <TooltipPanel
        header={<Label4>{label}</Label4>}
        content={<Body8 className="whitespace-pre-line">{tooltipCopy}</Body8>}
        className={`text-${IconSize.sm}`}
      />
    </Tooltip>
  );
};

export default TooltipButtonPanel;
